<template>
  <IndicatorWrapper class="star-indicator" :status="status" v-if="visible">
    <div class="title">{{t('trust')}}</div>
    <ValueBarMinimal :status="status" :data="barValue" :minimal="true"></ValueBarMinimal>
  </IndicatorWrapper>
</template>

<script>
import Api from '@/api'
import indData from '@/mixins/indData'
import indDynamicText from '@/mixins/indDynamicText'
import ValueBarMinimal from '@/components/IndicatorCards/parts/charts/ValueBarMinimal'
import IndicatorWrapper from '@/components/IndicatorCards/parts/IndicatorWrapper'

export default {
  name: 'StarIndicator',
  mixins: [indData, indDynamicText],

  components: {
    ValueBarMinimal,
    IndicatorWrapper
  },
  // mounted(){
  //   this.visible = true
  // },
  computed:{
    // no tiene texto, pero neceista esto para que sea "reactive" a los cambios del "timescale"
    dynamicTextData (){
      return [
        {
          type: 'select',
          id: 'timeScale',
        }
      ]
    },
    indicatorData() {
      return {
        main_value: {
          required: true,
          get () {
            return Api.getIndicatorData('ind_trust',this.currentFilters,{jumpOnError:true})
          }
        }
      }
    },
    barValue () {
      if(this.indicatorData.main_value && this.indicatorData.main_value.data.length > 0){
        return this.indicatorData.main_value.data.find(el => el.id == "commerce-sector-total")
      }
      return false
    }
  },

}
</script>

<style lang="stylus" scoped>
.star-indicator
  display flex
  flex-direction column
  .mobile &
    flex-direction: row
    align-items center
    >>> .indicator-content
      align-items: center;
  .title
    flex 0 0 auto
    font-family 'Anton'
    font-weight bold
    m-font-size(12,12)
    // margin 0px 0 vh(10px) 0
    .desktop &
      m-font-size(14,21)
      // margin 0px 0 vh(5px) 0
  .value-bar
    flex 1 1 auto
    margin 0px vw(10px) 0 vw(10px)
    height vh(40px)
    width: 100%;

  >>> .loader
    .icon
      display none
    .text
      display none
  
  >>> .no-data
    display none

</style>